<template>
  <main class="authorization-content authorization-content_bg">
    <div class="autorization">
      <div class="autorization__body popup box bg-white">
        <form id="temporary-password-form" name="temporary-password-form" @submit.prevent="submitForm" method="post">
          <div class="popup__header">
            <div class="popup__title section__title section__title_style3">{{$t("passwordRecovery")}}</div>
            <div class="popup__logo svg-icon" aria-hidden="true">
              <svg role="img" width="63" height="24" aria-hidden="true">
                <use xlink:href="#svg-logo-mobile"></use>
              </svg>
            </div>
          </div>
          <div class="popup__body">
            <div class="form-group">
              <label class="form-label form-label_hidden" for="password">{{$t("password")}}</label>
              <input class="form-control" type="password" @blur="this.v$.password.$touch()" :class="{is_invalid: v$.password.$error}"
                     v-model.trim="password" name="password" id="password" :placeholder='$t("password")'>
              <div class="form-validator" :class="{is_invalid: v$.password.$error}">{{$t("incorrectPassword")}}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label form-label_hidden" for="password_confirm">{{$t("repeatPassword")}}</label>
              <input class="form-control" type="password" @blur="this.v$.password_confirm.$touch()" :class="{is_invalid: v$.password_confirm.$error}"
                     v-model.trim="password_confirm" name="password_confirm" id="password_confirm"
                     :placeholder='$t("repeatPassword")'>
              <div class="form-validator" :class="{is_invalid: v$.password_confirm.$error}">{{$t("incorrectRepeatPass")}}</div>
            </div>

          </div>
          <div class="popup__footer">
            <div class="row align-items-center justify-content-between">
              <div class="col-12 col-sm-auto order-sm-last">
                <button class="btn btn_default btn_white" type="submit">{{$t("change")}}</button>
              </div>
              <div class="col-12 col-sm-auto">
                <router-link class="link link_gray" to="/password-recovery">{{$t("cancel")}}</router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
import useValidate from "@vuelidate/core";
import {required, email, sameAs, minLength} from "@vuelidate/validators";
import {mapActions} from 'vuex'

export default {
  data() {
    return {
      v$: useValidate(),
      password: '',
      password_confirm: '',
    }
  },
  validations() {
    return {
      password: {
        required,
        minLength: minLength(8),
        containsUppercase: function (value) {
          return /[A-Z]/.test(value)
        },
        containsLowercase: function (value) {
          return /[a-z]/.test(value)
        },
        containsNumber: function (value) {
          return /[0-9]/.test(value)
        },
      },
      password_confirm: {
        required,
        sameAsPassword: sameAs(this.password),
      },
    }
  },
  methods: {
    ...mapActions({
      resetComplatePassword: 'authorization/resetComplatePassword',
    }),
    submitForm() {
      this.v$.$validate()
      let {password, password_confirm} = this
      // let locHrefData = document.location.href.split('/')

      let uidb64 = this.$route.query.i
      let token = this.$route.query.t

      // if (locHrefData[locHrefData.length-1]){
      //   let token = locHrefData[locHrefData.length-1];
      //   let uidb64 = locHrefData[locHrefData.length-2];
      // }else{
      //   let token = locHrefData[locHrefData.length-2];
      //   let uidb64 = locHrefData[locHrefData.length-3];
      // }
      if (!this.v$.$error) {
        this.resetComplatePassword({password, password_confirm, token, uidb64}).then((res) => {
          // todo: check status message
          if (res === 200) {
            this.$router.push('/login')
            toastr.success(this.$t("editSuccess"));
          } else {
            toastr.error(this.$t("isError"));
            console.log('error recovery password')
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.is_invalid {
  border: 1px solid #df1717;
  opacity: 1;
  visibility: inherit;
}
.form-validator{
    font-size: .8em;
}
</style>